import React, { useEffect } from "react";
import { Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import Zoom from "react-medium-image-zoom";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmailIcon from "@mui/icons-material/Email";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
import { useParams } from "react-router-dom";
import moment from "moment";

function TenentManagInfoView() {
  // const navigate = useNavigate();

  // const [pdfImage, setPdfImage] = React.useState(
  //   require("../../../assets/Images/pdf.png")
  // );

  // const [txtImage, setTxtImage] = React.useState(
  //   require("../../../assets/Images/text.png")
  // );
  // const [excelImage, setExcelImage] = React.useState(
  //   require("../../../assets/Images/exel.png")
  // );
  // const [wordImage, setWordImage] = React.useState(
  //   require("../../../assets/Images/doc.png")
  // );
  // const [defaultProfilePic, setDefaultProfilePic] = React.useState(
  //   require("../../../assets/Images/avtarPic.png")
  // );

  const pdfImage = require("../../../assets/Images/pdf.png");
  const txtImage = require("../../../assets/Images/text.png");
  const excelImage = require("../../../assets/Images/exel.png");
  const wordImage = require("../../../assets/Images/doc.png");
  const defaultProfilePic = require("../../../assets/Images/avtarPic.png");

  // For According
  const [expanded, setExpanded] = React.useState(false);
  const handleChange2 = (panel) => (event2, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  // End

  const { tenentId } = useParams();

  const [firstname, setfirstname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [contact, setcontact] = React.useState("");
  const [email, setemail] = React.useState("");
  const [age, setage] = React.useState("");
  const [family_mem_cnt, setfamily_mem_cnt] = React.useState(0);
  const [profilePic, setProfilePic] = React.useState("");
  const [, setparkingsloat] = React.useState("");
  const [famlisting, setfamlisting] = React.useState([]);
  const [documentList, setDocumentList] = React.useState([]);
  const [vehilisting, setvehilisting] = React.useState([]);
  const [uniq_apt_name, setuniq_apt_name] = React.useState([]);
  const [ownerName, setOwnerName] = React.useState("");
  const [occupiedDate, setOccupiedDate] = React.useState("");
  const [releasedDate, setReleasedDate] = React.useState("");

  async function viewTenent() {
    let bodyFormData = "";
    makeGetRequest("resident/tenanthistory/" + tenentId, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log(response);

          let tenentObj = response.data.data[0];
          console.log(tenentObj);

          setfirstname(tenentObj.user_obj.first_name);
          setlastname(tenentObj.user_obj.last_name);
          setcontact(tenentObj.user_obj.contact_no);
          setemail(tenentObj.user_obj.email_id);
          setage(tenentObj.user_obj.age);
          setfamily_mem_cnt(tenentObj.family_count);
          setProfilePic(tenentObj.user_obj.profile_pic);
          // setresidentty(tenentObj.resident_type)
          setparkingsloat(tenentObj.allocated_parking);
          setfamlisting(tenentObj.tenentfamily);
          setvehilisting(tenentObj.tenentvehicle);
          setDocumentList(tenentObj.document_list);
          setuniq_apt_name(tenentObj.uniq_apt_name[0]);
          setOwnerName(
            tenentObj.owner.user_obj.first_name +
            " " +
            tenentObj.owner.user_obj.last_name
          );
          setOccupiedDate(tenentObj.occupied_date);
          setReleasedDate(tenentObj.released_date);
          // console.log("response.data.tenentList[0].tenent_id " + response.data.tenentList[0].t);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  useEffect(() => {
    viewTenent();
  }, []);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Tenant Details</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="serviceProViderViewMain">
                <div className="serviceProViderViewInner">
                  <div className="residentContMain">
                    <div className="providerOuter">
                      <div className="mainTenantTxOut">
                        <h4 className="mainTenantTx">
                          Owner Name: <b>{ownerName}</b>
                        </h4>
                      </div>

                      <div className="providerOutProfilDiv">
                        <Zoom>
                          <div className="provideImgDiv">
                            {profilePic ? (
                              <img src={profilePic} />
                            ) : (
                              <img src={defaultProfilePic} />
                            )}
                          </div>
                        </Zoom>
                        <h4 className="tenantAndAgeOut">
                          <span>
                            {firstname} {lastname}
                          </span>
                          <p className="ageText">({age})</p>
                        </h4>

                        {/* <span className="ageSubText">
                          {}
                          <em className="wingsSubTex">Owner</em>
                        </span> */}
                        <span className="ageSubText">
                          {uniq_apt_name}
                          <em className="wingsSubTex">Tenant</em>
                        </span>
                      </div>
                      <div className="tenantNewSecOut">
                        <div className="visitBottCont">
                          <p>Occupied Date</p>
                          <b>{moment(occupiedDate).format("DD-MM-YYYY")}</b>
                        </div>
                        <div className="visitBottCont">
                          <p>Released Date</p>
                          {releasedDate ? (
                            <b>{moment(releasedDate).format("DD-MM-YYYY")}</b>
                          ) : (
                            <b>-</b>
                          )}
                        </div>
                        <div className="visitBottCont">
                          <p>Occupied / Released</p>
                          {releasedDate ?
                            <b>Released</b>
                            :
                            <b>Occupied</b>}
                        </div>
                      </div>
                    </div>
                  </div>

                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <div className="tabViewOfProvider">
                        <ul>
                          <li>
                            <span>Phone Number</span> <b>{contact}</b>
                          </li>
                          <li>
                            <span>Email Id</span> <b>{email}</b>
                          </li>
                          <li>
                            <span>Family Members</span>{" "}
                            <b>{family_mem_cnt} Members</b>
                          </li>
                          {/* <li>
                            <span>Parking Slot</span> <b>101</b>
                          </li> */}
                        </ul>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <div className="tabViewOfProviderRight">
                        <h4 className="doquProviderHed">Documents</h4>
                        {documentList.length > 0 ? (
                          <>
                            {documentList.map((option, index) => (
                              <div className="doquOut" key={index}>
                                <div className="doquView1">
                                  <Zoom>
                                    <div className="doquView">
                                      {option.split(".").pop() == "txt" ? (
                                        <img src={txtImage} />
                                      ) : option.split(".").pop() == "pdf" ? (
                                        <img src={pdfImage} />
                                      ) : option.split(".").pop() == "docx" ||
                                        option.split(".").pop() == "doc" ? (
                                        <img src={wordImage} />
                                      ) : option.split(".").pop() == "xls" ||
                                        option.split(".").pop() == "xlsx" ? (
                                        <img src={excelImage} />
                                      ) : (
                                        <img src={option} />
                                      )}
                                    </div>
                                  </Zoom>
                                  <span>
                                    <a href={option}>
                                      {option.split("/").pop()}{" "}
                                    </a>
                                  </span>
                                </div>
                                {/* <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div> */}
                              </div>
                            ))}
                          </>
                        ) : (
                          <div>No Documents Uploaded...</div>
                        )}
                      </div>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <div className="acordingViewMain persnlInfoAcordingMain">
                        <Accordion
                          expanded={expanded === "panel1"}
                          onChange={handleChange2("panel1")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography>Family Details</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="acordingCont">
                              <div className="familyMemDetail familyMemDetailMain">
                                <h4
                                  className="doquProviderHed"
                                  style={{ textAlign: "left" }}
                                >
                                  Family Details
                                </h4>
                                <Grid
                                  container
                                  spacing={3}
                                  style={{ marginTop: "20px" }}
                                >
                                  {famlisting ? (
                                    <>
                                      {famlisting.map((option, index) => (
                                        <Grid item xs={12} md={6}>
                                          <div
                                            className="familyMemDetailsMain"
                                            key={index}
                                          >
                                            <div className="familyMemDetailsInner">
                                              <div className="familyMemDetailsTop">
                                                <div className="familyMemDetailsProfile">
                                                  <Zoom>
                                                    {option.user_obj
                                                      .profile_pic ? (
                                                      <img
                                                        src={
                                                          option.user_obj
                                                            .profile_pic
                                                        }
                                                      />
                                                    ) : (
                                                      <img
                                                        src={defaultProfilePic}
                                                      />
                                                    )}
                                                  </Zoom>
                                                </div>
                                                <h4>
                                                  {option.user_obj.first_name}
                                                </h4>
                                                <span>
                                                  {" "}
                                                  (Mother) {
                                                    option.user_obj.age
                                                  }{" "}
                                                  Year old
                                                </span>
                                              </div>
                                              <div className="familyMemDetailsDetels">
                                                <span>
                                                  <LocalPhoneIcon />{" "}
                                                  <b>
                                                    {option.user_obj.contact_no}
                                                  </b>
                                                </span>
                                                <span>
                                                  <EmailIcon />{" "}
                                                  {option.user_obj.email_id}
                                                </span>
                                                {/* <span className="flatWingNo">
                                          <MeetingRoomIcon /> dreamhigh/p/F-2101
                                          </span> */}
                                              </div>
                                            </div>
                                          </div>
                                        </Grid>
                                      ))}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </Grid>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={expanded === "panel2"}
                          onChange={handleChange2("panel2")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography>Vehicle Details</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="acordingCont">
                              <div className="vehicelAndDoquMain">
                                <div className="vehiclMainDetails">
                                  <h4 className="doquProviderHed">
                                    Vehicle Details
                                  </h4>
                                  {vehilisting ? (
                                    <>
                                      {vehilisting.map((option, index) => (
                                        <div
                                          className="vehicelAndDoquIner"
                                          key={index}
                                        >
                                          <div className="tabViewOfProvider">
                                            <ul>
                                              {/* <label>Vehicle {index + 1}</label> */}
                                              <li>
                                                <span>Owner Name</span>{" "}
                                                <b>
                                                  {option.vehicle_owner_name}
                                                </b>
                                              </li>
                                              <li>
                                                <span>Vehicle Type</span>{" "}
                                                <b>{option.vehicle_type}</b>
                                              </li>
                                              <li>
                                                <span>Vehicle Number</span>{" "}
                                                <b>{option.vehicle_no}</b>
                                              </li>
                                            </ul>
                                          </div>
                                          {option.document_list ? (
                                            <div className="tabViewOfProviderRight">
                                              {option.document_list.map(
                                                (option) => (
                                                  <div className="doquOutMain">
                                                    <div className="doquOut">
                                                      <div className="doquView1">
                                                        <Zoom>
                                                          <div className="doquView">
                                                            {option
                                                              .split(".")
                                                              .pop() ==
                                                              "txt" ? (
                                                              <img
                                                                src={txtImage}
                                                              />
                                                            ) : option
                                                              .split(".")
                                                              .pop() ==
                                                              "pdf" ? (
                                                              <img
                                                                src={pdfImage}
                                                              />
                                                            ) : option
                                                              .split(".")
                                                              .pop() ==
                                                              "docx" ||
                                                              option
                                                                .split(".")
                                                                .pop() ==
                                                              "doc" ? (
                                                              <img
                                                                src={wordImage}
                                                              />
                                                            ) : option
                                                              .split(".")
                                                              .pop() ==
                                                              "xls" ||
                                                              option
                                                                .split(".")
                                                                .pop() ==
                                                              "xlsx" ? (
                                                              <img
                                                                src={excelImage}
                                                              />
                                                            ) : (
                                                              <img
                                                                src={option}
                                                              />
                                                            )}
                                                          </div>
                                                        </Zoom>
                                                        <span>
                                                          <a href={option}>
                                                            {option
                                                              .split("/")
                                                              .pop()}
                                                          </a>
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            <div></div>
                                          )}
                                        </div>
                                      ))}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default TenentManagInfoView;
